import { FlightGoogleProvider } from "./google";
// import { FlightInsiderProvider } from "./insider"; // ileride
// import { FlightSegmentifyProvider } from "./segmentify"; // ileride
import appConfig from "@/configs/app-config";

/**
 * Uçak Analytics Service
 * Tüm provider'ları yönetir (Google, Insider, Segmentify vb.)
 */
export class FlightAnalyticsService {
  constructor() {
    this.providers = [];

    // Google Analytics
    if (appConfig.THIRD_PARTY_OPTIONS.GOOGLE.ANALYTICS.ACTIVE) {
      this.providers.push(new FlightGoogleProvider());
    }

    // Insider (ileride)
    // if (appConfig.THIRD_PARTY_OPTIONS.INSIDER.ACTIVE) {
    //   this.providers.push(new FlightInsiderProvider());
    // }

    // Segmentify (ileride)
    // if (appConfig.THIRD_PARTY_OPTIONS.SEGMENTIFY.ACTIVE) {
    //   this.providers.push(new FlightSegmentifyProvider());
    // }
  }

  /**
   * Event'i tüm aktif provider'lara gönderir
   * @param {string} event
   * @param {object} data
   */
  track(event, data) {
    this.providers.forEach((provider) => {
      try {
        provider.track(event, data);
      } catch (error) {
        console.error(`Flight Analytics Provider Error:`, error);
      }
    });
  }
}

export const flightService = new FlightAnalyticsService();
